var createUserdata = require('./userdata');

var storage;

if(window.localStorage){
    storage = window.localStorage;
}
else {
    storage = (function () {
        var filename = 'localstorage_and_userdata';
        return {
            setItem: function (key, value) {
                var userdata = createUserdata(filename);
                userdata.load();
                userdata.setAttribute(key, value);
                userdata.save();
            },
            getItem: function (key) {
                var userdata = createUserdata(filename);
                userdata.load();
                var value = userdata.getAttribute(key);
                return value;
            },
            removeItem: function (key) {
                var userdata = createUserdata(filename);
                userdata.load();
                userdata.removeAttribute(key);
                userdata.save();
            }
        };
    })();
}

module.exports =  storage;